import { safeDayjs } from "./formsHelper.js";

export const createOutlookEventData = (nodeValues, formValues, formWidgetList) => {
  let eventData = [];
  if(nodeValues.extractFromTable) {
    const tableData = formValues[nodeValues.dataTable] || [];
    const currentTableColumns = formWidgetList.find(widget => widget.id === nodeValues.dataTable)?.columns || []
    const guestEmailsList = Array.isArray(nodeValues.guestEmails)
      ? nodeValues.guestEmails
      : (nodeValues.guestEmails ? [nodeValues.guestEmails] : [])

    eventData = tableData.flatMap((row, rowIndex) => {
      let dateKeyToBeMapped = nodeValues.meetingDate?.split("::")?.[1]
      let timeKeyToBeMapped = nodeValues.meetingTime?.split("::")?.[1]
      const dateKey = Object.keys(row).find(k => k === dateKeyToBeMapped);
      const timeKey = Object.keys(row).find(k => k === timeKeyToBeMapped);

      const parsedDate = dateKey ? safeDayjs(row[dateKey]) : null;
      const parsedTime = timeKey ? safeDayjs(row[timeKey], ["HH:mm", "hh:mm A"]) : null;

      if (!parsedDate || !parsedDate.isValid()) {
        throw new Error(`Meeting date is missing or invalid in row ${rowIndex + 1}.`);
      }
      if (!parsedTime || !parsedTime.isValid()) {
        throw new Error(`Meeting time is missing or invalid in row ${rowIndex + 1}.`);
      }

      const startDate = parsedDate.format("YYYY-MM-DD");
      const startTime = parsedTime.format("HH:mm");

      const seenEmails = new Set();
      const rowEvents = [];
      guestEmailsList.forEach(guestEmail => {
        const emailKeyToBeMapped = guestEmail?.split("::")?.[1]
        const emailKey = Object.keys(row).find(k => k === emailKeyToBeMapped);
        const currentEmailOptions = currentTableColumns.find(widget => widget.id === emailKey)?.options || []
        let emailValue = row[emailKey] || ""
        if(currentEmailOptions.length > 0 && emailValue) {
          const matchedOption = currentEmailOptions.find(option => option.value === emailValue)
          emailValue = matchedOption ? matchedOption.label : emailValue
        }

        if (!emailValue || seenEmails.has(emailValue)) return;
        seenEmails.add(emailValue);

        rowEvents.push({
          startDate,
          startTime,
          email: emailValue
        });
      })
      return rowEvents;
    })
  }
  return eventData
}
